import React from 'react'
import { gtmEvent } from 'lib/gtm'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'
import StepDescriptionOfferings from '../step-description-offerings'
import { useStyles } from './styles'
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined'
import { DownloadMyPGAsection } from 'components/download-mypga-section'
import StudentCard from './student-card'
import BookingSummaryCoachInfo from '../components/BookingSummaryCoachInfo'

const SummaryLayout = ({
  idOrSlug,
  lessonType,
  lessonTypeId,
  locationId,
  student,
  lessonCreditBalanceQuantity,
}) => {
  const { coach } = lessonType

  const classes = useStyles()
  const bookNewSessionUrl = `/coach/${idOrSlug}/schedule?lessonTypeId=${lessonTypeId}&locationId=${locationId}&lessonCreditBalanceQuantity=${lessonCreditBalanceQuantity}`

  const onBookAnotherSession = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-book-another-session-button',
    })
    window.location.href = bookNewSessionUrl
  }

  const onViewCoachOfferings = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-view-coachofferings-button',
    })
    window.location.href = window.location.pathname
  }

  return (
    <Container className={classes.root}>
      <Grid container justifyContent="center">
        <Grid item md={7} xs={12}>
          <StepDescriptionOfferings
            stepText=""
            title="Thank you!"
            description="Your booking is complete. You will receive a confirmation email shortly."
          />
          <Alert
            severity="info"
            className={classes.warningBox}
            icon={
              <ConfirmationNumberOutlinedIcon
                color="primary"
                fontSize="small"
              />
            }
          >
            <strong>We have applied one of the lessons from your pack.</strong>
            You have {lessonCreditBalanceQuantity} lessons left.
            <br />
          </Alert>

          <Divider style={{ margin: '8px 0px 40px' }} />
          <Grid container spacing={2}>
            <Typography
              variant="h3"
              className={classes.detailsTitle}
              gutterBottom
            >
              Details
            </Typography>
          </Grid>
          <Grid container style={{ marginBottom: '2rem' }}>
            <BookingSummaryCoachInfo lessonType={lessonType} coach={coach} />
          </Grid>
          <StudentCard student={student} />
          <Divider className={classes.dividerStyles} />
          <Grid container spacing={2} className={classes.buttonWrapper}>
            <Grid item xs={6}>
              <Button
                variant="outlined"
                className={classes.buttonOverrideOfferings}
                onClick={onViewCoachOfferings}
              >
                View Coach Offerings
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                className={classes.buttonOverrideBook}
                onClick={onBookAnotherSession}
              >
                Book another session
              </Button>
            </Grid>
          </Grid>
          <DownloadMyPGAsection />
        </Grid>
      </Grid>
    </Container>
  )
}

export default SummaryLayout
